import React, { useState } from "react";
import './contact.css';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [submitting, setSubmitting] = useState(false);
  const [copiedEmail, setCopiedEmail] = useState(false);

  const copyEmailToClipboard = () => {
    navigator.clipboard.writeText('rishabhverma3648@gmail.com');
    setCopiedEmail(true);
    setTimeout(() => setCopiedEmail(false), 2000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault(); 
    setSubmitting(true);

    const API_URL = 'https://sheetdb.io/api/v1/ya8ppzt0a2usf';

    fetch(API_URL, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            data: {
                ...formData,
                timestamp: new Date().toLocaleString()
            }
        })
    })
    .then((response) => response.json())
    .then(() => {
      alert("Success! Your message has been sent.");
      setFormData({ name: '', email: '', message: '' });
      setSubmitting(false);
    })
    .catch((error) => {
      console.error('Error:', error);
      alert("Error: Something went wrong. Please try again.");
      setSubmitting(false);
    });
  };

  return (
    <div className="contact-page-container">
      <div className="contact-grid">
        {/* Left Info Column */}
        <div className="contact-info">
          <span className="section-tag">Outreach</span>
          <h1>Let's Build Something Great.</h1>
          <p>
            Whether you are looking to hire a founding engineer, discuss a custom AI pipeline, or build a scalable SaaS application, drop me a message or book a call.
          </p>

          <div className="contact-methods">
            <div className="contact-card-item premium-card">
              <div className="contact-card-label">
                <span>E-Mail</span>
                <span>rishabhverma3648@gmail.com</span>
              </div>
              <button className="copy-badge-btn" onClick={copyEmailToClipboard}>
                {copiedEmail ? '✓ Copied!' : 'Copy Address'}
              </button>
            </div>

            <div className="contact-card-item premium-card">
              <div className="contact-card-label">
                <span>Phone / WhatsApp</span>
                <span>+91-6290253034</span>
              </div>
              <a href="tel:+916290253034">
                <button className="copy-badge-btn">Call Now</button>
              </a>
            </div>
          </div>

          <div className="scheduler-banner premium-card">
            <h3>Schedule a Call</h3>
            <p>Prefer to sync live? Click below to book a quick 15-minute introductory meeting on my calendar.</p>
            <a href="https://calendly.com" target="_blank" rel="noopener noreferrer">
              <button className="copy-badge-btn" style={{ background: 'var(--text-primary)', color: 'var(--bg-primary)', fontWeight: 600 }}>Book Meeting</button>
            </a>
          </div>
        </div>

        {/* Right Form Column */}
        <form className="contact-form premium-card" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Your Name</label>
            <input 
              type="text" 
              id="name"
              name="name" 
              placeholder="Enter your name" 
              className="input-premium" 
              value={formData.name}
              onChange={handleChange}
              required 
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Your E-mail</label>
            <input 
              type="email" 
              id="email"
              name="email" 
              placeholder="Enter your email" 
              className="input-premium" 
              value={formData.email}
              onChange={handleChange}
              required 
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">What are you looking to build?</label>
            <textarea 
              id="message"
              rows="5" 
              name="message" 
              className="input-premium" 
              placeholder="Tell me about your project, timeline, or open role..."
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button className="btn-submit-premium" type="submit" disabled={submitting}>
            {submitting ? 'Sending Request...' : 'SEND INQUIRY'}
          </button>
        </form>
      </div>
    </div>
  );
}